




































import Vue from 'vue'
import Component from 'vue-class-component'
import {Action, State} from 'vuex-class'
import Event from '@/modules/reservation/model/Event'
import {Prop} from 'vue-property-decorator'
import {notify} from '@/modules/core/notification'
import ColorPickerField from '@/components/ColorPickerField.vue';

/**
 * Detalle de evento
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {ColorPickerField},
})
export default class EventDetail extends Vue {
    /**
     * Control la visibilidad del componente
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Evento seleccionado por el usuario
     */
    @State(state => state.reservation.currentEvent)
    public event: Event

    /**
     * Guarda los cambios del evento actualmente en edición
     */
    @Action('reservation/saveEvent')
    public saveEvent: () => void

    /**
     * Indica si la información del formulario es válida
     */
    public valid = true

    public saving = false

    /**
     * Reglas de validación para el formulario
     */
    public rules = {
        name: [
            (v: string) => !!v || 'El nombre no puede estar vacío',
        ],
    }

    public async save () {
        this.saving = true
        try {
            await this.saveEvent()
            notify(`El evento ${this.event.name} se ha guardado correctamente`)
            this.$emit('input', false)
        } catch (e) {
            notify(`Ha ocurrido un error: ${e.message}`)
        }

        this.saving = false
    }
}
